module.exports = __webpack_public_path__ + "img/fleetvaluationsystem.254f7d4d.png";